import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
    const [token, setToken] = useState(() => localStorage.getItem("admin_token"));
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        let cancelled = false;
        async function verify() {
            if (!token) {
                setChecked(true);
                return;
            }
            try {
                await api.get("/admin/verify");
            } catch {
                if (!cancelled) {
                    localStorage.removeItem("admin_token");
                    setToken(null);
                }
            } finally {
                if (!cancelled) setChecked(true);
            }
        }
        verify();
        return () => {
            cancelled = true;
        };
    }, [token]);

    const login = async (username, password) => {
        const { data } = await api.post("/admin/login", { username, password });
        localStorage.setItem("admin_token", data.token);
        setToken(data.token);
        return data.token;
    };

    const logout = () => {
        localStorage.removeItem("admin_token");
        setToken(null);
    };

    return (
        <AdminAuthContext.Provider value={{ token, checked, login, logout }}>
            {children}
        </AdminAuthContext.Provider>
    );
}

export function useAdminAuth() {
    const ctx = useContext(AdminAuthContext);
    if (!ctx) throw new Error("useAdminAuth must be inside AdminAuthProvider");
    return ctx;
}
